"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OverdueBalance = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.OverdueBalance = typebox_1.Type.Object({
    first_name: typebox_1.Type.String(),
    invoice_number: typebox_1.Type.String(),
    days_overdue: typebox_1.Type.Number(),
    payment_link: typebox_1.Type.String(),
});
//# sourceMappingURL=overdue-balance.js.map